<template>
  <div class="col-12">
    <Search
      :allowFields="$lang.ticketLang.ticketSearch"
      :allowCollapse="false"
      :url="url"
      :title="$lang.ticketLang.ticket_list"
      addModalSize="xl"
      removeModalSize="xl"
      :visibleSearch="true"
      :visibleSettings="true"
      :visibleExport="true"
      :visibleFilters="true"
      :visibleViewCount="true"
      :visibleAdd="false"
      :allowEdit="false"
      :editByRowClick="true"
      primaryKey="code"
      :dynamicButtons="availableButtons"
      ref="ticketSearch"
    >
      <template slot="headerButtons">
        <b-button
          class="ml-2 btn-lightgray"
          @click="AddTikect"
          v-b-tooltip.hover
          :title="$lang.search.add_tooltip"
        >
          <i class="fa fa-plus" aria-hidden="true"></i>
        </b-button>
      </template>
    </Search>
  </div>
</template>

<script>
import Search from "@/components/base/search";

export default {
  components: {
    Search,
  },

  data() {
    return {
      url: this.$config.api_url + this.$config.ticket.base,
      availableButtons: [
        {
          id: "0",
          name: "edit",
        },
        {
          id: "1",
          name: "view",
        },
      ],
    };
  },
  methods: {
    AddTikect() {
      this.$router.push({
        name: "user_add_ticket",
      });
    },
  },
};
</script>

